import React from 'react';
import LevelBadge from './LevelBadge';
import { formatDate, getDisplayName } from '../utils/helpers';
import './UserCardModal.css';

const UserCardModal = ({ user, onClose }) => {
  if (!user) return null;
  const displayName = getDisplayName(user);
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div className="user-card-backdrop" role="dialog" aria-modal="true">
      <div className="user-card-modal">
        <button className="user-card-close" type="button" onClick={onClose} aria-label="關閉">×</button>
        <div className="user-card-banner" style={{ backgroundImage: user.profile_banner_url ? `url(${user.profile_banner_url})` : undefined }} />
        <div className="user-card-content">
          {user.avatar_url ? <img className="user-card-avatar" src={user.avatar_url} alt={displayName} /> : <div className="user-card-avatar user-card-avatar-empty">{initial}</div>}
          <h2>{displayName}</h2>
          {user.nickname && <p className="user-card-subtitle">{user.name}</p>}
          <LevelBadge userId={user.id} />
          <div className="user-card-grid">
            <div><span>入職日</span><strong>{user.joined_at ? formatDate(user.joined_at) : '-'}</strong></div>
            <div><span>聯絡方式</span><strong>{user.contact_info || '-'}</strong></div>
            <div><span>LINE</span><strong>{user.line_id || '-'}</strong></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCardModal;